import { useEffect, useState } from 'react';
import { api } from '../api';
import { Permission } from '../data/Permission';
import { usePartner } from './usePartner';

export function usePermission() {
    const [permission, setPermission] = useState<Permission>();
    const [isLoading, setLoading] = useState(true);
    const { partner, partnerLineUid } = usePartner();

    useEffect(() => {
        if (partner) {
            setLoading(true);
            api.permission({
                line_uid: partnerLineUid || '',
                login: partner?.email || '',
            }).then((data) => {
                setLoading(false);
                setPermission(data);
            }).catch(() => {
                setLoading(false);
            });
        }
    }, [partner]);

    return {
        permission,
        isLoading,
    };
}
